import Map from '../map/RxGoogleMap';
import { useFeatureFlag } from '../../hooks/use-feature-flag';

const layerConfig = [
  { id: 'soyrx-early', name: 'Soy Rx Early', visible: true },
  { id: 'soyrx-late', name: 'Soy Rx Late', visible: true },
];

export default function SoyRxMap() {
  const isVpiEnabled = useFeatureFlag('ProductPlacementVPI');
  if (isVpiEnabled) layerConfig.push({ id: 'vpi', name: 'VPI', visible: true });

  return <Map layers={layerConfig} />;
}
